module.exports = __webpack_public_path__ + "static/media/05-08.8a238993.png";